import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

const campaignsSearchableItem = objectOf({
  id: string,
  value: string,
  is_draft: boolean,
});

export const isCampaignsSearchableResult = objectOf({
  campaigns: arrayOf(campaignsSearchableItem),
});
